export const reviewProposalsCount = 20;
